import { Typography } from "@mui/material";

interface ICustomTitle {
	variant?: any;
	fontSize?: string;
	textAlign?: any;
	color?: string;
	children: any;
	fontWeight?: any;
	letterSpacing?: string;
}

export default function CustomTitle(props: ICustomTitle) {
	const {
		variant = "h1",
		fontSize = "2rem",
		children,
		textAlign = "center",
		color = "#000",
		fontWeight = "bold",
		letterSpacing = "0.05em",
	} = props;
	return (
		<Typography
			variant={variant}
			style={{
				width: "100%",
				display: "block",
				textDecoration: "none",
				fontSize: fontSize,
				textAlign: textAlign,
				color: color,
				fontFamily: "Bebas Neue",
				fontWeight,
				letterSpacing,
			}}
		>
			{children}
		</Typography>
	);
}
